"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base64url_1 = __importDefault(require("base64url"));
const create_hash_1 = __importDefault(require("create-hash"));
const { canonize } = require('jsonld');
const sha256 = (data) => {
    return create_hash_1.default('sha256').update(data).digest();
};
class DigestService {
    normalizeJsonLd(data, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataWtihoutContext = Object.assign({}, data);
            delete dataWtihoutContext['@context'];
            return canonize(dataWtihoutContext, { expandContext: context });
        });
    }
    normalizeLdProof(proof, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const toNormalize = Object.assign({}, proof);
            delete toNormalize.signatureValue; // to support already created creds
            delete toNormalize.id; // to support already created creds
            delete toNormalize.jws;
            delete toNormalize.type;
            return this.normalizeJsonLd(toNormalize, context);
        });
    }
    getJsonLdDigest(document) {
        return __awaiter(this, void 0, void 0, function* () {
            let signature;
            const { proof } = document;
            const context = document['@context'];
            const data = Object.assign({}, document);
            delete data.proof;
            delete data['@context'];
            const normalizedProof = yield this.normalizeLdProof(proof, context);
            const normalizedData = yield this.normalizeJsonLd(data, context);
            const digest = sha256(Buffer.concat([sha256(Buffer.from(normalizedProof)), sha256(Buffer.from(normalizedData))]));
            if (document.proof && document.proof.signatureValue) {
                signature = Buffer.from(document.proof.signatureValue, 'hex');
            }
            if (document.proof && document.proof.jws) {
                signature = Buffer.from(document.proof.jws, 'hex');
            }
            return { digest, signature };
        });
    }
    getTokenDigest(token) {
        let signature;
        // prettier-ignore
        const toSign = [
            base64url_1.default(JSON.stringify(token.header)),
            base64url_1.default(JSON.stringify(token.payload))
        ].join('.');
        const digest = sha256(Buffer.from(toSign));
        if (token.signature) {
            const isSignatureValidHex = /^[a-fA-F0-9]+$/.test(token.signature);
            signature = isSignatureValidHex ? Buffer.from(token.signature, 'hex') : null;
        }
        return { digest, signature };
    }
}
exports.default = DigestService;
//# sourceMappingURL=DigestService.js.map